// Shared TinyMCE setup; every form used to carry its own slightly different copy
export const tinymceApiKey = process.env.VUE_APP_TINYMCE_API_KEY

export function editorConfig(overrides = {}) {
    return {
        menubar: false,
        statusbar: true,
        branding: false,
        height: 360,
        resize: true,
        plugins: [
            'advlist autolink lists link image charmap print preview anchor',
            'searchreplace visualblocks fullscreen emoticons code',
            'insertdatetime media table paste help wordcount'
        ],
        fontsize_formats: '8px 10px 12px 14px 18px 24px 36px',
        toolbar: 'undo redo | styleselect | forecolor | bold italic | fontselect fontsizeselect | emoticons | alignleft aligncenter alignright alignjustify | numlist bullist | outdent indent | link image | code fullscreen',
        ...overrides
    }
}
